const types = {
  POST_SUPPORT_REQUEST_SUCCESS: 'support/POST_SUPPORT_REQUEST_SUCCESS',
};

export default types;
